<div class="dialog-content">
  <form class="k-form" [formGroup]="invoicePositionForm">
    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start !k-justify-content-flex-start k-mt-2"
        [for]="description"
        text="Beschreibung"
      ></kendo-label>
      <kendo-editor
        [formControlName]="formControlNames.Description"
        class="text-editor"
        [plugins]="editorPlugins"
        #description
      >
        <kendo-toolbar>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
          <kendo-toolbar-dropdownlist
            kendoEditorFontFamily
            [data]="editorFontFamilies"
          ></kendo-toolbar-dropdownlist>
        </kendo-toolbar>
      </kendo-editor>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="price" text="Preis"></kendo-label>
      <kendo-numerictextbox
        [spinners]="false"
        format="m2"
        [formControlName]="formControlNames.Price"
        #price
      >
      </kendo-numerictextbox>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>
  </form>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4" (click)="close()">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton class="!k-pr-4" themeColor="base" size="large" (click)="submit()">
    <fa-icon class="update k-text-white k-mr-3" [icon]="faPenToSquare"></fa-icon>
    <span class="label">Aktualisieren</span>
  </button>
</footer>
